import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { SecureStorageService } from '../../../Services/secure-storage.service';


@Component({
  selector: 'app-checkbox-services-list',
  templateUrl: './checkbox-services-list.component.html'
})
export class CheckboxServicesListComponent implements OnInit {

  @Input() dyServicesList: [];
  @Input() currencyType:string;
  private serviceArray: any = [];
  private readonly secureStorageService: SecureStorageService;

  @Output() onServiceSelection: EventEmitter<any> = new EventEmitter<any>();


  constructor() {
    // This is intentional
  }
  

  private getCheckboxValues(event, data) {
    if (event.target.checked) {
      // Pushing the object into array
      this.serviceArray.push(data);

    } else {
      const element = this.serviceArray.find(item => item === data);

      if (element) {
        this.serviceArray.splice(this.serviceArray.indexOf(element), 1);
      }
    }

    // Duplicates the obj if we uncheck it
    // How to remove the value from array if we uncheck it
    this.onServiceSelection.emit(this.serviceArray);
  }

  ngOnInit(): void {
    // This is intentional
  }


 
}
